
import React from "react"

import Layout2 from "../components/layout2"
import SEO from "../components/seo"

import App from "../components/appOralB";
import AppBarn from "../components/appBarn";
import AppLyx from "../components/appLyx";
import InternLinks from "../components/internlinks";
import { Breadcrumb } from "../components/globals/breadcrumb";

const OralBPage = () => (
  <Layout2>
      <Breadcrumb category={["nyheter", "nyheter"]}  page={["Oral b eltandborste", "oralb"]}/>  
     <SEO title="Oral b eltandborste" description="Vi testar Oral Bs eltandborstar" keywords={[`Orla B`, `eltandborste`, `vita tänder`, `fint leende`, `2021`]}/>
     <section className="section-metoder">
     <main>
       <img src="../oralb.jpg" alt="Oral B" width="100%"/>
       <h1 class="welcome">Oral B</h1>
       <p class="text-center">
       Oral B har under många år arbetat med utveckling av munvårdsprodukter. 
       Idag är det eltandborstar och tillhörande borsthuvuden som är de största, men även Oral B tandkräm och mundusch är populära.
       Välj Oral B Kids eltandborste till ditt barn, så får du en modell som är perfekt anpassad till barnets mun.
       </p>

</main>
        <section className="section-cards">
  <main className="card__ai">
     <h2 class="card-rubrik">Våra favoriter</h2>
     <h3 class="card__smRubrik">Ta hand om dina tänder</h3>
    <App />
    </main>
  </section>
</section>
  <section className="section-metoder">
     <main>
        <p class="text-center">Oral B är världsledande när det kommer till tandborstar. 
        Företaget har med sina högkvalitativa munvårdsprodukter etablerat sig högst upp på toppen 
        av näringskedjan och utvecklas ständigt mot nya marknader. Oral B, är det tandborstmärke 
        som används mest av professionella tandläkare över hela världen och deras eltandborstar.
        </p>
    </main>
    </section>
                    <section className="section-cards">
  <main className="card__ai">
     <h2 class="card-rubrik">Barnens favoriter</h2>
    <AppBarn />
    </main>
  </section>
    <section className="section-metoder">
     <main>
        <h3 class="welcome">Oral B för barn</h3> 
<p class="text-center">
    Oral-B Vitality tandborste rengör barns tänder skonsamt med ett speciellt och barnvänligt mjukt borstläge. 
    Oral-B Vitality-borsthuvudet har extra mjuka borststrån som är varsamma mot tandköttet och framtagna för små munnar 
för en skonsam och överlägsen rengöring.
</p>
    <h3 class="welcome">Inbyggd tvåminuterstimer</h3>
    <p class="text-center">Oral-B Vitality tandborste har en inbyggd timer så att ditt barn borstar i de 2 minuter 
    som rekommenderas av tandläkare, vilket främjar goda, livslånga munvårdsrutiner.</p>
    <h3 class="welcome">Uppladdningsbart batteri</h3>
    <p class="text-center">Oral-B Vitality laddningsbart batteri håller tandborsten laddad i 8 timmar. 
    En roligare tandborstningsstund – bara ett enkelt knapptryck bort. Tandborsten inkluderar ett laddningsstativ som enkelt får plats på handfatet eller badrumsskåpet.</p>
    <p></p>
        <h3 class="welcome">Varför är denna tandborste så rolig för barn i åldern 3+ år?</h3>
    <p class="text-center">
     Vitality-tandborsten inkluderar 4 st. Disney-klistermärken som barn kan klistra på handtaget för att göra den till en personlig favorit. Andra Vitality-tandborstar har karaktärer med karaktärer från filmerna Disney Frozen, Disney·Pixar Toystory, Disney Princess och Disney·Pixar Cars.
     Den kostnadsfria Disney Magic Timer App från Oral-B uppmuntrar borstning i 2 minuter enligt rekommendation av tandläkare. Ju mer barnet borstar, desto fler bilder kan låsas upp. Det finns till och med en praktisk kalender där barnet kan följa framstegen.
    </p>
        </main>
        </section>
          <section className="section-cards">
  <main className="card__ai">
     <h2 class="card-rubrik">Oral Bs lyxmodeller</h2>
     <h3 class="card__smRubrik">Lyxen för dina tänder</h3>
    <AppLyx />
    </main>
  </section>
       <main>
       <h3 class="welcome">Oral Bs rolls royce</h3>
       <p class="text-center">
       Oral B har tagit fram eltandborstar som med hjälp av artificiell intelligens kan identifiera ditt sätt att borsta och guida dig till 
       dina bästa resultat varje dag. Nu är det enklare än någonsin att borsta som tandläkare rekommenderar för en överlägsen 
       rengöring och för friskare tandkött. 
       </p>
</main>
<section className="section-cards card-height">
  <main>
      <h2 class="internal-rubrik">Bästa tandblekningen hemma</h2>
    <InternLinks />
    </main>
  </section>


  </Layout2>
)

export default OralBPage
